import $ from 'jquery';
import 'slick-carousel';
import 'select2';
import '../components/menu';
import '../components/announcement';
import '../components/sliders/hero';
import '../components/sliders/grid';
import '../components/gravityforms';
import '../components/words/intro';
import '../../sass/home.scss';

$(document).ready(function () {
	$("a[href$='#intro-component']").on('click', function (e) {
		e.preventDefault();
		$('html, body').animate(
			{
				scrollTop: $('#intro-component').offset().top,
			},
			900,
			'swing'
		);
	});
	function isInViewport(element) {
		let win = $(window);
		let viewport = {
			left: win.scrollLeft(),
			top: win.scrollTop(),
		};
		viewport.bottom = viewport.top + win.height();
		viewport.right = viewport.left + win.width();
		var bounds = element.offset();
		bounds.bottom = bounds.top + element.outerHeight();
		bounds.right = bounds.left + element.outerWidth();
		return !(
			viewport.bottom < bounds.top ||
			viewport.left > bounds.right ||
			viewport.right < bounds.left ||
			viewport.top > bounds.bottom
		);
	}
});
